import { VehicleType } from 'core/types/vehicleType';

import { Action, SET_VEHICLE_TYPES } from './actions';

export default (state: VehicleType[] = [], action: Action) => {
  switch (action.type) {
    case SET_VEHICLE_TYPES:
      return action.payload;
    default:
      return state;
  }
};
